import {z} from 'zod'

import {CreateOrUpdateBlockAwardRowDocument} from '@sdox/api'

import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {i18nValidation} from '../../../../../i18n'

import type {BlockAwardInput, CreateOrUpdateBlockAwardRowMutation} from '@sdox/api'

type CreateAwardsValidatorSchema = z.infer<typeof createAwardsValidatorSchema>

const createAwardsValidatorSchema = z.object({
  data: z.array(
    z.object({
      // image is selected as XcMediaRef from MediaLibrary
      image: z.object({
        // md5 hashes are actually 16 bytes long, but if the hash algorithm changes
        //  we would have a very hard to find bug if we expect a hard 16 chars.
        fileHash: z.string().min(1),
      }),
      text: z.string().min(1, {message: i18nValidation.enterText}),
      title: z.string().min(1, {message: i18nValidation.enterText}),
    }).required(),
  ),
  meta: createMetaSchema,
})

export const awardsConfig = createFormConfig<
  CreateAwardsValidatorSchema,
  CreateOrUpdateBlockAwardRowMutation,
  BlockAwardInput[]
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockAwardRowDocument,
  },
  fieldMapper: (fieldValues) => (
    fieldValues.data.map((item) => ({
      title: item.title,
      text: item.text,
      fileHash: item.image.fileHash,
    }))
  ),
  validatorSchema: createAwardsValidatorSchema,
  inputFields: [
    {
      label: 'Award',
      inputType: 'array',
      required: true,
      description: '',
      fieldName: 'data',
      placeholder: '',
      defaultValue: undefined,
      fields: [
        {
          label: 'Image',
          fieldName: 'image',
          inputType: 'image',
          defaultValue: '',
          required: true,
        },
        {
          label: 'Title',
          fieldName: 'title',
          inputType: 'text',
          defaultValue: '',
          required: true,
        },
        {
          label: 'Text',
          fieldName: 'text',
          inputType: 'text',
          defaultValue: '',
          required: true,
        },
      ],
    },
  ],
})
